import { render, staticRenderFns } from "./SingleWork.vue?vue&type=template&id=6d8e08d8&lang=pug&"
import script from "./SingleWork.vue?vue&type=script&lang=js&"
export * from "./SingleWork.vue?vue&type=script&lang=js&"
import style0 from "./SingleWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports